import React, { useState, useRef } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import emailjs from '@emailjs/browser';
import '../styles/Flash.css';


const Coontact = () => {
    const ref=useRef(null);
  const [msg, setMsg] = useState('');
 let [visibility, setVisibility] = useState(false);
 let [type, setType] = useState('');
  const formik = useFormik({
	//we have created our initailValues object in a format EmailJS accepts
	initialValues: {


      user_name: '', //user name
	  to_name: process.env.REACT_APP_ADMIN_EMAIL, //email id of the admin
	  subject: '', // subject of email
	  user_email: '', // user email
	  message: '' // message of email
        },


	validationSchema: Yup.object({
        user_name: Yup.string()
		.required('* Name field is required'),
	   subject: Yup.string()
		.required('* Subject field is required'),
	   user_email: Yup.string().email('Invalid email address')
		.required('* Email field is required'),
	   message: Yup.string().required('* Message field is required')


	}),


	onSubmit: (values) => {

	  try{
        console.log(ref.current);
        emailjs.sendForm(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID, ref.current, process.env.REACT_APP_PUBLIC_KEY)
		  .then(() => {		  
           
            setVisibility(true);
            setMsg('Email sent successully, Deepu will reach out to you shortly :)');
            setType('success')
            setTimeout(() => {
            setVisibility(false);
            window.location.reload(true);
          }, 4000);
	          })   
             
            }
	   catch (err) {
        console.log(err);
        setVisibility(true);
        setMsg('Please try again');
        setType('error');
        setTimeout(() => {
            setVisibility(false);
          }, 2000);
	  }

     },


  });

  
  return(
    <>
    <div className='contact d-flex flex-column align-items-center'>
    { visibility && <div className={`alert alert-${type}`}>
                <p>{msg}</p>
            </div>}
    <form ref={ref} className="vh-100 w-25 container d-flex flex-column" onSubmit={formik.handleSubmit}>


            <label htmlFor="name" className="form-label">Name</label>
            <input
            id="name"
            className="form-control"
            name="user_name"
            type="text"
            autoComplete="off"
            placeholder="YOUR NAME"
            onChange={formik.handleChange}
            value={formik.values.name}
            />

            <div className={`text-danger expandable ${formik.touched.user_name && formik.errors.user_name ? 'show' : ''}`}>
                        {formik.errors.user_name}
            </div>


	    <div  className="col-12 ">

            <label htmlFor="subject" className="form-label">Subject</label>
            <input
            id="subject"
            className="form-control"
            name="subject"
            type="text"
            autoComplete="off"
            placeholder="SUBJECT"
            onChange={formik.handleChange}
            value={formik.values.subject}
            />
            <div className={` text-danger expandable ${formik.touched.subject && formik.errors.subject ? 'show' : ''}`}>
                        {formik.errors.subject}
            </div>


	    </div>



	    {/* <div  className="col-12 col-md-6"> */}


            <label htmlFor="reply_to" className="form-label" > Reply to</label>
            <input 
            id="reply_to"
            className="form-control" 
            type="email" 
            name="user_email" 
            placeholder="YOUR EMAIL"
            autoComplete="off"
            onChange={formik.handleChange}
            value={formik.values.email}
            />
            <div className={`text-danger expandable ${formik.touched.user_email && formik.errors.user_email ? 'show' : ''}`}>
                        {formik.errors.user_email}
            </div>


	    {/* </div> */}




	    <div  className="col-12">


            <label htmlFor="message" className="form-label">Message</label>
            <textarea 
            id="message" 
            className="form-control"
            name="message" 
            placeholder="YOUR MESSAGE"
            autoComplete="off" 
            onChange={formik.handleChange}
            value={formik.values.message}
            />
            <div className={`text-danger expandable ${formik.touched.message && formik.errors.message ? 'show' : ''}`}>
                        {formik.errors.message}
            </div>


	    </div>




        <div className="btn-container d-flex justify-content-center "> 
            <button disabled={formik.isSubmitting} type="submit" className="btn btn-primary mt-2 w-50 ">
                        <span>Send Message</span>
            </button>
        </div>

	    <div  className="col-12 form-message">

		    <span id='output'  className="output_message text-center text-uppercase" />

	    </div>
    </form>
    </div>
    </>
  );
};

export default  Coontact;